import { useEffect, useCallback, useRef } from 'react';

/**
 * Custom hook to manage badge count updates via IPC SDK
 * @param {Object} ipcManager - The IPC Manager instance from useIpcContactName
 * @param {boolean} ipcInitialized - Whether IPC is initialized
 * @returns {Object} - Object containing updateBadgeCount function
 */
export function useIpcBadgeUpdate(ipcManager, ipcInitialized) {
  const stateRef = useRef({ ipcManager: null, ipcInitialized: false });

  // Update refs when props change
  useEffect(() => {
    stateRef.current.ipcManager = ipcManager;
    stateRef.current.ipcInitialized = ipcInitialized;
  }, [ipcManager, ipcInitialized]);

  /**
   * Update the badge count on the host app
   * @param {number} count - The number of unread messages/sessions
   */
  const updateBadgeCount = useCallback((count) => {
    if (!stateRef.current.ipcInitialized || !stateRef.current.ipcManager) {
      console.log('[Badge] IPC not initialized or manager not available. Skipping badge update.');
      return;
    }

    try {
      console.log(`[Badge] Updating badge count to: ${count}`);
      stateRef.current.ipcManager.badgeUpdate(count, false);
    } catch (err) {
      console.error('[Badge] Failed to update badge count:', err);
    }
  }, []);

  return { updateBadgeCount };
}

